import instagram from '../../images/icons/instagram.svg';
import discord from '../../images/icons/discord.svg';
import twitter from '../../images/icons/twitter.svg';

const mapping = {
  'instagram': instagram,
  'discord': discord,
  'twitter': twitter
};

export { mapping };
